<template>
    <div id="vue-test" style="width: 100%;height: 500px;background-color: #FFEECC">
      <p>11111111111111111111</p>
      <div id="form-html" style="width: 200px;height: 200px;background-color: yellowgreen;" v-html="formHtml">
      </div>
      <a :href="formHtml">{{formHtml}}</a>
<!--      <form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway.do?charset=UTF-8&method=alipay.trade.wap.pay&sign=csm5%2BlBz8dWgJNlCZMSnIiJNS9uwuDj0pm%2Bj%2B7SjHgwImapB917h0S%2BMbnxjMRF84Pr3qy6EtTVfIPRnHMNJWpOVLs8aJHorcD8r%2FfzBWJ466UvMRp0w4ODdaoIapgUVXqgVRUHpf2lx1KyGnqx2ZuH8asGfCZlMEdPs%2FchDAAUyBopkT%2FQ%2BxFm3Eslg%2BZT%2BM0%2FrvrbHammECK%2FGQ5bldTS1BDmc%2Bee3RtYkE3uiYeuVXskN3BQPlhb7F0zBZ6EFYxJUaYboFtS88J6he2I53wtOZY4e12S9z8XpCDG7ECvNCGoVAaEKk%2FXD4exkYZJBjUMlg8s18ERdxwnyos6JQA%3D%3D&return_url=http%3A%2F%2Fwww.pay.org&notify_url=http%3A%2F%2Fproxy.xsplus.net%2Fnotify%2Fpay%2FaliPayNotifyRes.htm&version=1.0&app_id=2017051607251435&sign_type=RSA2&timestamp=2019-08-12+14%3A05%3A57&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json">-->
<!--        <input type="hidden" name="biz_content" value="{&quot;body&quot;:&quot;安全管家&quot;,&quot;out_trade_no&quot;:&quot;P0020190812140557000052&quot;,&quot;product_code&quot;:&quot;FAST_INSTANT_TRADE_PAY&quot;,&quot;qr_pay_mode&quot;:&quot;2&quot;,&quot;qrcode_width&quot;:200,&quot;subject&quot;:&quot;安全管家&quot;,&quot;total_amount&quot;:&quot;999.00&quot;}">-->
<!--        <input type="submit" value="立即支付" style="display:none" >-->
<!--      </form>-->
<!--      <form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway.do?charset=UTF-8&method=alipay.trade.wap.pay&sign=QESr%2BupMD9vfwTO%2FW3PTZ%2BFhTHMdwO2VoMP8DQH3snAW1F%2F6CH2jHCF1Kv8JhHgHT43QpUXYnNkQLiI%2BLu%2BkUy%2BuL3s3KKMRaa65XQ1JYPoe%2Fe%2FzWMWSM%2BzRgUBD8YYgbQOg9npz4taqq99kNI2PS%2FxXk7hnpKt0wU0rL%2FGHexdhZMD%2F%2BWkLvMTzIqEXupL50qo2DCg2xKXinxTtMzGu%2FqTrAQcg2crL%2BSTUjNZ6ztis%2F%2FSOYCHFEKoMjFHpzP1yKKHxD43pMgy%2FgurBeXGwVtyGpqqlR9xvnvMFCPoNW7wirfpN7wPQXSuFkeYSh2vn23sPmOonDLdkeWn9QWkpVA%3D%3D&return_url=http%3A%2F%2Fwww.pay.org&notify_url=http%3A%2F%2Fproxy.xsplus.net%2Fnotify%2Fpay%2FaliPayNotifyRes.htm&version=1.0&app_id=2017051607251435&sign_type=RSA2&timestamp=2019-08-09+09%3A17%3A39&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json">-->
<!--        <input type="hidden" name="biz_content" value="{&quot;body&quot;:&quot;商品名&quot;,&quot;out_trade_no&quot;:&quot;P0020190809091739000001&quot;,&quot;product_code&quot;:&quot;QUICK_WAP_PAY&quot;,&quot;subject&quot;:&quot;produtct&quot;,&quot;total_amount&quot;:&quot;0.01&quot;}">-->
<!--        <input type="submit" value="立即支付" style="display:none" >-->
<!--      </form>-->

      <!--      <script>document.forms[0].submit();</script>-->

<!--      <Circle :percent="100" stroke-color="#5cb85c">-->
<!--        <Icon type="ios-checkmark" size="60" style="color:#5cb85c"></Icon>-->
<!--      </Circle>-->
<!--      <Circle :percent="35" stroke-color="#ff5500">-->
<!--        <span class="demo-Circle-inner">-->
<!--            <Icon type="ios-close" size="50" style="color:#ff5500"></Icon>-->
<!--        </span>-->
<!--      </Circle>-->
<!--      <div style="width: 100%;background-color: yellow;">-->
<!--        <div id="myChart" style="width: 80%; height: 300px;background-color: yellowgreen"></div>-->
<!--      </div>-->
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
// import { Circle } from 'iview'
export default {
  data () {
    return {
      formHtml: ''
    }
  },
  methods: {
    payForm (payUrl) {
      this.formHtml = payUrl
      Toast('调起H5支付')
      if (this.formHtml.indexOf('http') === 0) { // 微信
        console.log('微信支付==============================')
        window.location.href = this.formHtml

        // // payUrl 订单号
        // this.orderClick()
      } else { // 支付宝
        console.log('支付宝支付==============================')
        setTimeout(function () {
          document.forms[0].submit()
        }, 500)
      }
    },
    formClick: function () {
      document.forms[0].submit()
    },
    initEChart: function () {
      var rate2Chart = this.echarts.init(document.getElementById('myChart'))
      // 指定图表的配置项和数据
      var option = {
        color: ['#c41335', '#003366'],
        title: {
          text: '配置项和数据',
          x: 'center',
          textStyle: {
            color: '#000000',
            fontWeight: 'bold',
            fontSize: 15,
            textAlign: 'center'
          }
        },
        tooltip: {},
        legend: {
          // type: 'scroll',
          // orient: 'vertical',
          // show: true,
          // left: 'center',
          // data: ['按照国家应安装个数', '实际安装个数']
        },
        xAxis: {
          type: 'category',
          data: ['1', '3', '11']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '标准',
            type: 'bar',
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'top'
            //   }
            // },
            data: ['12', '22', '11']
          },
          {
            name: '实际',
            type: 'bar',
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'top'
            //   }
            // },
            data: ['22', '22', '1']
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      rate2Chart.setOption(option)
    }
  },
  comments: {
    // Circle
  },
  mounted () {
    window.payForm = this.payForm
    // this.payForm()

    // this.initEChart()
  }
}

// window.payForm = this.payForm
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/vue-test.vue